import './App.css'
import '@tribeplatform/react-ui-kit/styles'
import './lib/wdyr'

import { Hydrate, Provider } from '@tribeplatform/react-sdk'
import { ToastContainer } from '@tribeplatform/react-ui-kit/Toast'

import { AppInitialProps } from './@types'
import { GenericMeta } from './components/GenericMeta'
import { Intercom } from './lib/intercom/provider'
import { Optimizely } from './lib/optimizely/Provider'
import { Routes } from './Routes'
import { ThemeProvider } from './themes/ThemeProvider.component'
import { TribeWeb } from './TribeWeb'
import { onClientError } from './utils/onError'

export const App = ({
  pageProps,
  apiUrl,
}: {
  pageProps: AppInitialProps
  apiUrl: string
}) => (
  <Provider
    config={{
      baseUrl: apiUrl,
      networkDomain: pageProps?.authToken?.network?.domain,
      accessToken: pageProps?.authToken?.accessToken,
      onError: onClientError(pageProps),
    }}
  >
    <Hydrate state={pageProps.dehydratedState}>
      <Optimizely datafile={pageProps.optimizelyDataFile}>
        <GenericMeta pageProps={pageProps} />
        <Intercom authToken={pageProps?.authToken}>
          <ThemeProvider appearance={pageProps.appearance}>
            <TribeWeb pageProps={pageProps}>
              <Routes pageProps={pageProps} />
              <ToastContainer />
            </TribeWeb>
          </ThemeProvider>
        </Intercom>
      </Optimizely>
    </Hydrate>
  </Provider>
)
